// The Offered cell: whether resellers see the TLD, saved as soon as it is switched. Withdrawing
// takes the place of removing: resellers stop seeing it and keep what they set for it, which
// the toast says. Fixed for staff who only read.
import type { TldPricing } from "@kilat/contracts/tld-pricing";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { m } from "@/lib/paraglide/messages.js";
import { pricingError } from "../pricing-error";
import { useSetTldOffered } from "./mutation";

export function TldOfferedSwitch({ tld, editable }: { tld: TldPricing; editable: boolean }) {
  const toggle = useSetTldOffered(tld.id);
  const name = `.${tld.tld}`;

  function change(offered: boolean) {
    toggle.mutate(offered, {
      onSuccess: () => toast.success((offered ? m.tld_pricing_offered_on : m.tld_pricing_offered_off)({ tld: name })),
      onError: (error) => toast.error(pricingError(error)),
    });
  }

  return (
    <Switch
      checked={tld.offered}
      disabled={!editable || toggle.isPending}
      aria-label={m.tld_pricing_offered_label({ tld: name })}
      onCheckedChange={change}
    />
  );
}
